import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { GeneralCalculatorComponent } from './general-calculator/general-calculator.component';
import { NavigationBarComponent } from './navigation-bar/navigation-bar.component';
import { AppointmentsComponent } from './appointments/appointments.component';
import { RecommendationsComponent } from './recommendations/recommendations.component';
import { OffersComponent } from './offers/offers.component';
import { DocumentsComponent } from './documents/documents.component';
import { LoginComponent } from './login/login.component';
import { SignDocumentsComponent } from './sign-documents/sign-documents.component';
import { SignOnTheSpotComponent } from './sign-on-the-spot/sign-on-the-spot.component';
import { UploadDocumentsComponent } from './upload-documents/upload-documents.component';


const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  {
    path: 'sava',
    component: NavigationBarComponent,
    children: [
      {
        path: 'appointments',
        component: AppointmentsComponent
      },
      {
        path: 'calculator',
        component: GeneralCalculatorComponent,
        loadChildren: () => import('./calculators/calculators.module').then(m => m.CalculatorsModule)
      },
      {
        path: 'reports',
        loadChildren: () => import('./report-panel/report-panel.module').then(m => m.ReportPanelModule)
      },
      {
        path: 'recommendations',
        component: RecommendationsComponent
      },
      {
        path: 'offers',
        component: OffersComponent
      },
      {
        path: 'documents',
        component: DocumentsComponent
      },
      {
        path: 'admin',
        loadChildren: () => import('./admin-panel/admin-panel.module').then(m => m.AdminPanelModule)
      },
      {
        path: 'questionnaires',
        loadChildren: () => import('./questionnaire-panel/questionnaire-panel.module').then(m => m.QuestionnairePanelModule)
      },
      {
        path: 'nl',
        loadChildren: () => import('./nl/nl.module').then(m => m.NLModule)
      }
    ]
  },
  {
    path: 'sign-documents',
    component: SignDocumentsComponent
  },
  {
    path: 'sign-documents-on-spot/:offerid',
    component: SignOnTheSpotComponent
  },
  {
    path: 'upload-documents',
    component: UploadDocumentsComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
